import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {
        const { setStepApplilication } = globalStates
        const { FormScreen } = Forms

        FormScreen.onResetForm()
        setStepApplilication(0)
        handleClickShowForm(false)

    }

    const handleClickFetchAllLegalDocuments = async () => {

        const { fetchAllLegalDocuments } = FetchData
        const { executeFetch } = fetchAllLegalDocuments

        executeFetch()

    }

    const handleClickFetchSpecificLegalDocument = async (iddocument) => {
        
        const { setFormOpeningMode } = globalStates

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        const { fetchSpecificLegalDocument } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificLegalDocument

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddocument: iddocument})
        executeFetch()

        setFormOpeningMode('READONLY')
        handleClickShowForm(true)

    }

    const handleClickDeleteLegalDocument = async (iddocument) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal-notarial/delete-legal-documents/${iddocument}`)
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        handleClickFetchAllLegalDocuments()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
        
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickCloseForm = () => {
        const { setStepApplilication } = globalStates
        const { FormScreen, FormStamps } = Forms
        FormScreen.onResetForm()
        FormStamps.onResetForm()
        setStepApplilication(0)

        handleClickShowForm(false)
    }

    const handleClickFetchAllDocumentsStamps = async () => {

        const { fetchAllDocumentsStamps } = FetchData
        const { executeFetch } = fetchAllDocumentsStamps

        executeFetch()

    }

    const handleClickFetchSpecificDocumentsStamps = async (iddocumentsstamps) => {
        
        const { fetchSpecificDocumentsStamps } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificDocumentsStamps

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        handleClickResetStampsForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddocumentsstamps: iddocumentsstamps})
        executeFetch()

    }

    const handleClickDeleteDocumentsStamps = async (iddocumentstamps, idstamp, quantity) => {
        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/legal-notarial/delete-documents-stamps`, {
                    iddocumentstamps, idstamp, quantity, 
                })
                    .then(({ data }) => {
                        
                        alertMessage(data)
                        handleClickFetchAllDocumentsStamps()

                    })
                    .catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
        
    }

    const handleClickResetStampsForm = async () => {

        const { FormStamps } = Forms
        const { setFormState } = FormStamps

        setFormState(prevState => ({
            ...prevState,
            iddocumentstamps: '',
            idstamp: '',
            quantity: ''
        }))
        
    }

    const handleClickContinue = async () => {
        
        const { fetchAllDocumentsStamps } = FetchData
        const { FormScreen, FormStamps } = Forms

        FormStamps.formState.iddocument = FormScreen.formState.iddocument

        fetchAllDocumentsStamps.setParamsToSearch({iddocument: FormScreen.formState.iddocument})
        fetchAllDocumentsStamps.executeFetch()

        handleClickNextStep()
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchAllDocumentsStamps } = FetchData
        const { FormScreen, FormStamps } = Forms
        const { formState } = FormScreen

        const _dataBody = {
            iddocument: formState.iddocument,
            date_document: formState.date_document,
            idprocesstype: formState.idprocesstype,
            idlawyer: formState.idlawyer,
            observations: formState.observations,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.iddocument > 0){

            await marvarApi.put( `/legal-notarial/update-legal-documents/${_dataBody.iddocument}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    handleClickFetchAllLegalDocuments()
                    FormStamps.formState.iddocument = formState.iddocument
                    fetchAllDocumentsStamps.setParamsToSearch({iddocument: formState.iddocument})
                    fetchAllDocumentsStamps.executeFetch()
                    handleClickNextStep()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal-notarial/create-legal-documents`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    if (data.flag === 'OK') {
                        const iddocument = data.rows[0].insertId
                        formState.iddocument = iddocument

                        FormStamps.formState.iddocument = formState.iddocument
                        fetchAllDocumentsStamps.setParamsToSearch({iddocument: formState.iddocument})
                        fetchAllDocumentsStamps.executeFetch()
                        handleClickFetchAllLegalDocuments()

                        handleClickNextStep()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitStampsForm = async (e) => {

        e.preventDefault()

        const { FormStamps } = Forms
        const { formState } = FormStamps

        const _dataBody = {
            iddocumentstamps: formState.iddocumentstamps,
            iddocument: formState.iddocument,
            idstamp: formState.idstamp,
            quantity: formState.quantity,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)
        await marvarApi.post( `/legal-notarial/create-documents-stamps`, _dataBody )
            .then(({ data }) => {

                // const iddocumentsstamps = data.rows[0].insertId
                // console.log('iddocumentsstamps ', iddocumentsstamps)
                alertMessage(data)
                handleClickFetchAllLegalDocuments()
                handleClickFetchAllDocumentsStamps()
                handleClickResetStampsForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })

        
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllLegalDocuments,
        handleClickFetchSpecificLegalDocument,
        handleClickDeleteLegalDocument,
        handleClickReturnStep,
        handleClickNextStep,
        handleClickCloseForm,
        handleClickFetchSpecificDocumentsStamps,
        handleClickContinue,
        handleClickDeleteDocumentsStamps,
        onSubmitForm,
        onSubmitStampsForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}